import Vue from "vue";
export default {
  getShiftSchedules({ state, commit }) {
    return new Promise((resolve, reject) => {
      const params = {
        page: state.page,
        perPage: state.perPage,
        ...state.schedularFormData,
      };
      commit("loading", true);
      Vue.$http
        .get("/attendance/shift/schedules", { params })
        .then(response => {
          commit("loading", false);
          const { results, total, dates } = response.data;
          commit("dates", dates);
          commit("shiftSchedules", results);
          commit("total", total);
          resolve(response);
        })
        .catch(error => {
          commit("loading", false);
          reject(error);
        });
    });
  },
  handleSizeChange({ commit, dispatch }, perPage) {
    commit("perPage", perPage);
    commit("page", 1);
    dispatch("getShiftSchedules");
  },

  handleCurrentChange({ commit, dispatch }, page) {
    commit("page", page);
    dispatch("getShiftSchedules");
  },
  updateShiftSchedules(_, payload) {
    return new Promise((resolve, reject) => {
      Vue.$http
        .post("/attendance/shift/schedules", payload)
        .then(response => {
          resolve(response);
        })
        .catch(error => {
          reject(error);
        });
    });
  },
  getShiftTypes({ commit }) {
    return new Promise((resolve, reject) => {
      Vue.$http
        .get("/attendance/shift/settings/shift-type")
        .then(response => {
          commit("shiftTypes", response.data);
          resolve(response);
        })
        .catch(error => {
          Vue.$notification.error(error.message, {
            offset: 120,
          });
          reject(error);
        });
    });
  },
};
